// extracted by mini-css-extract-plugin
export default {"container":"styles_container__L3IS+","ContentsWrapper":"styles_ContentsWrapper__xoarP","navbar":"styles_navbar__VYQCJ","tableDashboardNavbar":"styles_tableDashboardNavbar__VGXCD"};